import axios from 'axios';
import { authService } from './auth';
import { getApiUrl } from './apiBase';

const API_URL = getApiUrl();

export interface UploadResponse {
  url: string;
  key: string;
}

export const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

export const validateImageFile = (file: File) => {
  if (file.size > MAX_IMAGE_SIZE) {
    throw new Error('image-too-large');
  }
  if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
    throw new Error('unsupported-image');
  }
};

class ImageUploadService {
  private getAuthHeader() {
    const token = authService.getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  async uploadImage(file: File): Promise<UploadResponse> {
    validateImageFile(file);
    try {
      const { data } = await axios.post(`${API_URL}/upload/image`, file, {
        headers: {
          ...this.getAuthHeader(),
          'Content-Type': 'application/octet-stream',
        },
      });
      const imageBaseUrl = process.env.REACT_APP_S3_BUCKET_URL?.replace(/\/+$/, '');
      if (!imageBaseUrl) {
        throw new Error('Image storage URL is not configured');
      }
      const { key } = data as { key: string };
      return { url: `${imageBaseUrl}/${key}`, key };
    } catch (error) {
      console.error('Error uploading image:', error);
      const message = (error as any).response?.data?.message;
      throw new Error(message || 'Failed to upload image');
    }
  }

  async uploadMultipleImages(files: File[]): Promise<UploadResponse[]> {
    return Promise.all(files.map(file => this.uploadImage(file)));
  }
}

export const imageUploadService = new ImageUploadService();
